import { render, staticRenderFns } from "./modal_detallesSolicitante.vue?vue&type=template&id=18e15f86&"
import script from "./modal_detallesSolicitante.vue?vue&type=script&lang=js&"
export * from "./modal_detallesSolicitante.vue?vue&type=script&lang=js&"
import style0 from "./modal_detallesSolicitante.vue?vue&type=style&index=0&id=18e15f86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports